import { Stack } from "@mui/material";
import { useEffect } from "react";

import PaginationControlsV2 from "../../../global/PaginationControlsV2";
import useEntityLocationsData from "../hooks/useEntityLocationsData";
import { useEntityLocationsStore } from "../store/entityLocationsStore";

import EntityLocationsTable from "./EntityLocationsTable";

export default function EntityLocations({ entityId }) {
  const { reset, data, loading, resultCount, currentPage, resLimit, setCurrentPage } =
    useEntityLocationsStore();
  useEntityLocationsData(entityId);

  useEffect(() => reset, [reset]);

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="relative flex flex-1 flex-col gap-2 overflow-y-auto">
        <EntityLocationsTable data={data} isLoading={loading} />
      </div>
      {resultCount > resLimit && (
        <div className="relative flex w-full justify-center">
          <Stack alignItems="center">
            <PaginationControlsV2
              currentPage={currentPage}
              handleChange={(_event, page) => setCurrentPage(page)}
              resultCount={resultCount}
              resultLimit={resLimit}
            />
          </Stack>
        </div>
      )}
    </div>
  );
}
